import HttpCliente from "../HttpCliente";

export const getDocumentos = (pageNumber, pageSize, filters, token) => {
  return new Promise((resolve, reject) => {
    const queryParams = new URLSearchParams({
      pageNumber: pageNumber,
      pageSize: pageSize,
      // Filtros de texto
      ...(filters.searchTerm && { nombre: filters.searchTerm }),
      ...(filters.organismoEmisorId && { organismo: filters.organismoEmisorId }),
      ...(filters.tipoDocumentoId && { tipoDocumento: filters.tipoDocumentoId }),
      ...(filters.estadoTramitacionId && { estadoTramitacion: filters.estadoTramitacionId }),
      ...(filters.rubroId && { rubro: filters.rubroId }),
      ...(filters.clasificacionDocumentoId && { clasificacionDoc: filters.clasificacionDocumentoId }),
      ...(filters.clienteId && { cliente: filters.clienteId }),
      ...(filters.paisId && { pais: filters.paisId }),
      // Fechas y estado
      ...(filters.startDate && { fechaDesde: filters.startDate.toISOString() }),
      ...(filters.endDate && { fechaHasta: filters.endDate.toISOString() }),
      ...(filters.filterHabilitado && filters.filterHabilitado !== 'todos' && { estadoHabilitacion: filters.filterHabilitado }),
    });

    HttpCliente.get(`/Normativa/ObtenerNormativas?${queryParams}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const postDocumento = (token, documento) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post("/Normativa/Crear", documento, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
}

export const putDocumento = (token, documento) => {
  return new Promise((resolve, reject) => {
    HttpCliente.put("/Normativa/EditarNormativa", documento, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      console.error("Error al editar normativa:", error.response?.data || error);
      reject(error.response?.data?.message || "Error al editar normativa");
    });
  });
}

export const getDocumentoId = (token, id) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/Normativa/ObtenerNormativa/${id}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const deleteDocumento = (token, id) => {
  return new Promise((resolve, reject) => {
    HttpCliente.delete(`/Normativa/Deshabilitar/${id}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const eliminarNormativa = (token, id) => {
  return new Promise((resolve, reject) => {
    HttpCliente.delete(`/Normativa/Eliminar/${id}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      console.error("Error al eliminar normativa:", error.response?.data || error);
      reject(error.response?.data?.message || "Error al eliminar normativa");
    });
  });
};

export const getNormativasCliente = (token, id) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/Normativa/ObtenerNormativaCliente/${id}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
}

export const getNormativasClientePaginado = (token, id, pageNumber, pageSize, filtros) => {
  return new Promise((resolve, reject) => {
    
    const queryParams = new URLSearchParams({
      idUsuario: id,
      pageNumber: pageNumber,
      pageSize: pageSize,
      // Asegúrate de usar los nombres exactos que el backend espera
      ...(filtros.searchTerm && { nombre: filtros.searchTerm }),
      ...(filtros.organismo && { organismo: filtros.organismo }),
      ...(filtros.tipoDocumento && { tipoDocumento: filtros.tipoDocumento }),
      ...(filtros.estadoTramitacion && { estadoTramitacion: filtros.estadoTramitacion }),
      ...(filtros.cliente && { cliente: filtros.cliente }),
      ...(filtros.rubro && { rubro: filtros.rubro }),
      // Formato correcto para fechas
      ...(filtros.fechaDesde && { fechaDesde: filtros.fechaDesde.toISOString() }),
      ...(filtros.fechaHasta && { fechaHasta: filtros.fechaHasta.toISOString() }),
    });

    HttpCliente.get(`/Normativa/ObtenerNormativaClientePaginado?${queryParams}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      console.error("Error completo:", error.response || error);
      reject(error);
    });
  });
};

export const getNormativasClienteNoEnviadasPaginado = (token, id, pageNumber, pageSize, filtros) => {
  return new Promise((resolve, reject) => {
    
    const queryParams = new URLSearchParams({
      idUsuario: id,
      pageNumber: pageNumber,
      pageSize: pageSize,
      // Asegúrate de usar los nombres exactos que el backend espera
      ...(filtros.searchTerm && { nombre: filtros.searchTerm }),
      ...(filtros.organismo && { organismo: filtros.organismo }),
      ...(filtros.tipoDocumento && { tipoDocumento: filtros.tipoDocumento }),
      ...(filtros.estadoTramitacion && { estadoTramitacion: filtros.estadoTramitacion }),
      ...(filtros.cliente && { cliente: filtros.cliente }),
      ...(filtros.rubro && { rubro: filtros.rubro }),
      // Formato correcto para fechas
      ...(filtros.fechaDesde && { fechaDesde: filtros.fechaDesde.toISOString() }),
      ...(filtros.fechaHasta && { fechaHasta: filtros.fechaHasta.toISOString() }),
    });

    HttpCliente.get(`/Normativa/ObtenerNormativaClienteNoEnviadasPaginado?${queryParams}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      console.error("Error completo:", error.response || error);
      reject(error);
    });
  });
};

export const exportarNormativasExcel = (token, id, filtros) => {
  return new Promise((resolve, reject) => {
    // Construir QueryParams usando URLSearchParams para mayor seguridad
    const queryParams = new URLSearchParams({
      idUsuario: id
    });
    
    // Añadir parámetros solo si existen
    if (filtros.nombre) queryParams.append('nombre', filtros.nombre);
    if (filtros.organismo) queryParams.append('organismo', filtros.organismo);
    if (filtros.tipoDocumento) queryParams.append('tipoDocumento', filtros.tipoDocumento);
    if (filtros.estadoTramitacion) queryParams.append('estadoTramitacion', filtros.estadoTramitacion);
    if (filtros.cliente) queryParams.append('cliente', filtros.cliente);
    if (filtros.rubro) queryParams.append('rubro', filtros.rubro);
    // Formateo adecuado de fechas
    if (filtros.fechaDesde) queryParams.append('fechaDesde', filtros.fechaDesde.toISOString());
    if (filtros.fechaHasta) queryParams.append('fechaHasta', filtros.fechaHasta.toISOString());
    
    console.log(`URL de exportación: /Normativa/ExportarExcel?${queryParams.toString()}`);
    
    HttpCliente.get(`/Normativa/ExportarExcel?${queryParams.toString()}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'application/octet-stream'
      },
      responseType: 'blob'
    }).then(response => {
      // Verificar que hay datos en la respuesta
      console.log("Respuesta Excel recibida:", response);
      resolve(response.data);
    }).catch(error => {
      console.error("Error completo exportando Excel:", error.response || error);
      reject(error);
    });
  });
};

export const exportarDocumentosExcel = (filters, token) => {
  return new Promise((resolve, reject) => {
    const queryParams = new URLSearchParams({
      // Filtros de texto
      ...(filters.searchTerm && { nombre: filters.searchTerm }),
      ...(filters.organismoEmisorId && { organismo: filters.organismoEmisorId }),
      ...(filters.tipoDocumentoId && { tipoDocumento: filters.tipoDocumentoId }),
      ...(filters.estadoTramitacionId && { estadoTramitacion: filters.estadoTramitacionId }),
      ...(filters.rubroId && { rubro: filters.rubroId }),
      ...(filters.clasificacionDocumentoId && { clasificacionDoc: filters.clasificacionDocumentoId }),
      ...(filters.clienteId && { cliente: filters.clienteId }),
      ...(filters.paisId && { pais: filters.paisId }),
      // Fechas y estado
      ...(filters.startDate && { fechaDesde: filters.startDate.toISOString() }),
      ...(filters.endDate && { fechaHasta: filters.endDate.toISOString() }),
      ...(filters.filterHabilitado && filters.filterHabilitado !== 'todos' && { estadoHabilitacion: filters.filterHabilitado }),
    });

    HttpCliente.get(`/Normativa/ExportarExcelPaged?${queryParams}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
      },
      responseType: 'blob' // Esto es crítico para recibir datos binarios
    }).then(response => {
      console.log("Tamaño del blob recibido:", response.data.size);
      resolve(response.data);
    }).catch(error => {
      console.error("Error al exportar Excel:", error.response || error);
      reject(error);
    });
  });
};

export const verificarEnvioNormativa = (token, id) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/Normativa/VerificarEnvio/${id}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const marcarParaReenvio = (token, id, clienteIds = []) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post(`/Normativa/MarcarParaReenvio/${id}`, { clienteIds }, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      console.error("Error al marcar para reenvío:", error.response?.data || error);
      reject(error.response?.data?.message || "Error al marcar para reenvío");
    });
  });
};

export const getEstadoEnvioPorCliente = (token, id) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/Normativa/EstadoEnvio/${id}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const obtenerClientesDisponiblesReenvio = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get('/EnvioCorreo/clientes-disponibles', {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'application/json'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      console.error("Error al obtener clientes disponibles:", error.response?.data || error);
      reject(error.response?.data?.message || "Error al obtener clientes disponibles");
    });
  });
};

export const validarNormativaExiste = (token, normativaId) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/EnvioCorreo/validar-normativa/${normativaId}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'application/json'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const generarVistaPreviaReenvio = (token, data) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post('/EnvioCorreo/vistas-previas', data, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      console.error("Error al generar vista previa:", error.response?.data || error);
      reject(error.response?.data?.message || "Error al generar vista previa");
    });
  });
};

export const generarVistaPreviaClienteReenvio = (token, data) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post('/EnvioCorreo/vista-previa-cliente', data, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      console.error("Error al generar vista previa del cliente:", error.response?.data || error);
      reject(error.response?.data?.message || "Error al generar vista previa del cliente");
    });
  });
};

export const reenviarNormativa = (token, data) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post('/EnvioCorreo/reenviar', data, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      console.error("Error al reenviar normativa:", error.response?.data || error);
      reject(error.response?.data?.message || "Error al reenviar normativa");
    });
  });
};

export const importacionMasivaDocumentos = (token, idsNormativas, idCliente) => {
  return new Promise((resolve, reject) => {
    const payload = {
      idCliente: idCliente,
      idsNormativas: idsNormativas
    };

    HttpCliente.post('/Normativa/IntegracionExterna', payload, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      console.error("Error al importar normativas a GRC:", error.response?.data || error);
      reject(error.response?.data?.message || "Error al importar normativas a GRC");
    });
  });
};